import type { RootState } from 'features/store/store';

// to be used once user is Signed in - on protected routes
export const selectUser = (state: RootState) => {
  const user = state.auth.user;
  if (!user) {
    throw new Error('User is not signed in');
  }

  return user;
};

// to be used on where user state is uncertain, like during auth flow
export const selectOptionalUser = (state: RootState) => state.auth.user;

// Optimized selector for user language - prevents unnecessary re-renders
// when other user fields change
export const selectUserLanguage = (state: RootState): string =>
  state.auth.user?.language ?? 'en-US';
